export default __webpack_public_path__ + "static/media/and-digital.228d77c3.png";